import { createFileRoute, Outlet } from "@tanstack/solid-router";

export const Route = createFileRoute("/_dashboard/dashboard/settings")({
  staticData: {
    breadcrumb: "Settings",
  },
  component: () => <Outlet />,
});
